export enum PromoBoxType {
  Benefit = 'benefit',
  Event = 'event',
  News = 'news',
  AcademyVideo = 'academy-video',
  AcademyBook = 'academy-book',
  CDP = 'cdp',
  ConsultantGuide = 'consultant-guide',
  Referral = 'referral',
}

export interface IPromoBoxItem {
  id: string;
  type: PromoBoxType;
  title: string;
  image: string;
  url: string;
  date?: string;
  description: string;
}

export interface IPromoBoxCookie {
  [PromoBoxType.AcademyBook]: string[];
  [PromoBoxType.AcademyVideo]: string[];
  [PromoBoxType.Benefit]: string[];
  [PromoBoxType.Event]: string[];
  [PromoBoxType.News]: string[];
}

export interface IPromoBoxCookieWithExpiration extends IPromoBoxCookie {
  expirationDate: string;
}

export const PROMO_BOX_PAGES: Array<IPromoBoxItem> = [
  {
    id: 'cdp-page',
    description: 'Let us help you better plan your professional path.',
    image: '/assets/images/promo-box/page/cdp.png',
    title: 'Consultant Development Program',
    type: PromoBoxType.CDP,
    url: '/learning-and-dev/consultant-dev-program'
  },
  {
    id: 'consultant-guide-page',
    description: ' Check everything you need to know as a 7N Consultant.',
    image: '/assets/images/promo-box/page/consultant-guide.png',
    title: 'Consultant Guide',
    type: PromoBoxType.ConsultantGuide,
    url: '/consultant-guide'
  },
  {
    id: 'referral-page',
    description: ' Get a bonus by recommending to us your top 3% colleagues.',
    image: '/assets/images/promo-box/page/referral.png',
    title: 'Referrals',
    type: PromoBoxType.Referral,
    url: '/referrals'
  }
]